import React, { useEffect, useState } from "react";
import AddIcon from "@material-ui/icons/Add";
import { useSnackbar } from "notistack";
import Fab from "@material-ui/core/Fab";
import { makeStyles } from "@material-ui/core/styles";
import Table from "../../Table";
import { useTranslation } from "react-multi-lang";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { leadsService } from "../../../utils/feathers";
import { formatDate } from "../../../utils/utils";

const useStyles = makeStyles((theme) => ({
  fab: {
    margin: theme.spacing(1),
    right: 10,
    bottom: 10,
    left: "auto",
    position: "fixed",
  },
}));

function Leads() {
  const classes = useStyles();
  const history = useHistory();
  const t = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState({
    skip: 0,
    limit: 50,
    sort: { LeadId: -1 },
    query: {},
  });

  const changeFilters = ({ skip, query, sort }) => {
    setFilters((prev) => ({ ...prev, skip, query, sort }));
  };

  const errorMessage = t("common.error");

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await leadsService.find({
          query: {
            $limit: filters.limit,
            $skip: filters.skip,
            $or: filters.query,
            $sort: filters.sort,
          },
        });

        setTotal(data.total);
        setRows(data.data);
      } catch (e) {
        enqueueSnackbar(errorMessage, { variant: "error" });
      }

      setIsLoading(false);
    }

    fetchData();
  }, [filters, errorMessage, enqueueSnackbar]);

  const onDelete = async (id) => {
    await leadsService.remove(id);
  };

  const title = t("leads.title");

  return (
    <div>
      <Helmet>
        <title>Attis - {title}</title>
      </Helmet>
      <Table
        title={title}
        path="leads"
        idColumn="LeadId"
        tableColumns={[
          { title: t("leads.id"), name: "LeadId" },
          { title: t("leads.name"), name: "LeadName" },
          { title: t("leads.surname"), name: "LeadSurname" },
          { title: t("leads.email"), name: "LeadEmail" },
          { title: t("leads.phone"), name: "LeadPhone" },
          {
            title: t("leads.createdDate"),
            name: "CreatedDate",
            getCellValue: (row) =>
              row.createdAt ? formatDate(row.createdAt) : undefined,
          },
          {
            title: t("leads.lastContactedDate"),
            name: "LastContactedDate",
            getCellValue: (row) =>
              row.LastContactedDate
                ? formatDate(row.LastContactedDate)
                : undefined,
          },
        ]}
        tableRows={rows}
        totalRows={total}
        changeFilters={changeFilters}
        onDelete={onDelete}
        isLoading={isLoading}
      />
      <Fab
        color="primary"
        aria-label={t("common.new")}
        onClick={() => {
          history.push("/leads/new");
        }}
        className={classes.fab}
      >
        <AddIcon />
      </Fab>
    </div>
  );
}

export default Leads;
